document.addEventListener('DOMContentLoaded', function () {

  // ========================================
  // BASIC HELPERS
  // ========================================

  function money(cents) {
    var amount = Number(cents) / 100;
    return '$' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getData(prefix) {
    var element = document.getElementById(prefix + '-product-data');

    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('Subscription product data error:', prefix, error);
      return null;
    }
  }


  // ========================================
  // DATE HELPERS
  // ========================================

  function parseLocalDate(value) {
    if (!value) return null;

    var parts = value.split('-');

    if (parts.length !== 3) {
      return null;
    }

    return new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );
  }

  function formatDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  function formatDisplayDate(date) {
    return date.toLocaleDateString(
      'en-US',
      {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }
    );
  }

  function addDays(date, days) {
    var result = new Date(date);

    result.setDate(
      result.getDate() + Number(days || 0)
    );

    return result;
  }

  function isSunday(date) {
    return date.getDay() === 0;
  }


  // ========================================
  // U.S. FEDERAL HOLIDAYS
  // ========================================

  function nthWeekdayOfMonth(
    year,
    month,
    weekday,
    nth
  ) {
    var date = new Date(
      year,
      month,
      1
    );

    while (
      date.getDay() !== weekday
    ) {
      date.setDate(
        date.getDate() + 1
      );
    }

    date.setDate(
      date.getDate() +
      (nth - 1) * 7
    );

    return date;
  }

  function lastWeekdayOfMonth(
    year,
    month,
    weekday
  ) {
    var date = new Date(
      year,
      month + 1,
      0
    );

    while (
      date.getDay() !== weekday
    ) {
      date.setDate(
        date.getDate() - 1
      );
    }

    return date;
  }

  function observedFixedHoliday(
    year,
    month,
    day
  ) {
    var actual = new Date(
      year,
      month,
      day
    );

    var observed = new Date(actual);

    if (actual.getDay() === 6) {
      observed.setDate(
        observed.getDate() - 1
      );
    } else if (
      actual.getDay() === 0
    ) {
      observed.setDate(
        observed.getDate() + 1
      );
    }

    return observed;
  }

  function getFederalHolidayDates(year) {
    var holidays = [];

    function add(date) {
      holidays.push(
        formatDate(date)
      );
    }

    function addFixed(
      month,
      day
    ) {
      var actual =
        new Date(
          year,
          month,
          day
        );

      var observed =
        observedFixedHoliday(
          year,
          month,
          day
        );

      add(actual);
      add(observed);
    }

    // New Year's Day
    addFixed(0, 1);

    // Martin Luther King Jr. Day
    add(
      nthWeekdayOfMonth(
        year,
        0,
        1,
        3
      )
    );

    // Washington's Birthday / Presidents Day
    add(
      nthWeekdayOfMonth(
        year,
        1,
        1,
        3
      )
    );

    // Memorial Day
    add(
      lastWeekdayOfMonth(
        year,
        4,
        1
      )
    );

    // Juneteenth
    addFixed(5, 19);

    // Independence Day
    addFixed(6, 4);

    // Labor Day
    add(
      nthWeekdayOfMonth(
        year,
        8,
        1,
        1
      )
    );

    // Columbus Day
    add(
      nthWeekdayOfMonth(
        year,
        9,
        1,
        2
      )
    );

    // Veterans Day
    addFixed(10, 11);

    // Thanksgiving
    add(
      nthWeekdayOfMonth(
        year,
        10,
        4,
        4
      )
    );

    // Christmas
    addFixed(11, 25);

    return Array.from(
      new Set(holidays)
    );
  }

  function isFederalHoliday(date) {
    if (!date) {
      return false;
    }

    var value =
      formatDate(date);

    return getFederalHolidayDates(
      date.getFullYear()
    ).indexOf(value) !== -1;
  }


  // ========================================
  // FULFILLMENT RULES
  // ========================================

  function isClosedDate(date) {
    return (
      isSunday(date) ||
      isFederalHoliday(date)
    );
  }

  /*
    This is ONLY for recurring dates that
    automatically land on a federal holiday.

    Rule:

    1. Try one day BEFORE the holiday.
    2. If that day is Sunday or another
       federal holiday, try one day AFTER.
    3. Continue forward if necessary.

    The adjustment affects only that delivery.
    It never changes the base schedule for
    later deliveries.
  */

  function adjustRecurringHoliday(date) {
    var original =
      new Date(date);

    if (!isFederalHoliday(original)) {
      return {
        date: original,
        adjusted: false
      };
    }

    var before =
      addDays(original, -1);

    if (!isClosedDate(before)) {
      return {
        date: before,
        adjusted: true
      };
    }

    var after =
      addDays(original, 1);

    while (isClosedDate(after)) {
      after =
        addDays(after, 1);
    }

    return {
      date: after,
      adjusted: true
    };
  }


  // ========================================
  // FREQUENCY
  // ========================================

  function getFrequencySettings(value) {
    var normalized =
      normalize(value);

    if (
      normalized.indexOf('weekly') !== -1 &&
      normalized.indexOf('biweekly') === -1
    ) {
      return {
        count: 4,
        intervalDays: 7
      };
    }

    if (
      normalized.indexOf('biweekly') !== -1
    ) {
      return {
        count: 2,
        intervalDays: 14
      };
    }

    return {
      count: 1,
      intervalDays: 0
    };
  }


  // ========================================
  // BUILD DELIVERY SCHEDULE
  // ========================================

  function buildDeliverySchedule(
    firstDate,
    frequencyValue
  ) {
    var settings =
      getFrequencySettings(
        frequencyValue
      );

    var schedule = [];

    for (
      var i = 0;
      i < settings.count;
      i++
    ) {
      /*
        IMPORTANT:

        Every original date is calculated
        from the customer's FIRST date.

        Holiday adjustments do NOT shift
        later deliveries.
      */

      var originalDate =
        addDays(
          firstDate,
          settings.intervalDays * i
        );

      var result =
        adjustRecurringHoliday(
          originalDate
        );

      schedule.push({
        originalDate:
          originalDate,

        date:
          result.date,

        adjusted:
          result.adjusted
      });
    }

    return schedule;
  }


  // ========================================
  // SUBSCRIPTION FORM
  // ========================================

  function bind(prefix) {

    var data =
      getData(prefix);

    var size =
      document.getElementById(
        prefix + '-size'
      );

    var frequency =
      document.getElementById(
        prefix + '-freq'
      );

    var dateInput =
      document.getElementById(
        prefix + '-date'
      );

    var timeSelect =
      document.getElementById(
        prefix + '-time'
      );

    var scheduleBox =
      document.getElementById(
        prefix + '-schedule'
      );

    var scheduleList =
      document.getElementById(
        prefix + '-schedule-list'
      );

    var variantInput =
      document.getElementById(
        prefix + '-id'
      );

    var planInput =
      document.getElementById(
        prefix + '-plan'
      );

    var price =
      document.getElementById(
        prefix + '-price'
      );

    var form =
      document.getElementById(
        prefix + '-form'
      );


    if (
      !data ||
      !size ||
      !frequency ||
      !dateInput ||
      !timeSelect ||
      !scheduleBox ||
      !scheduleList ||
      !variantInput ||
      !planInput ||
      !form
    ) {
      console.log(
        'Subscription form not found:',
        prefix
      );

      return;
    }


    // ========================================
    // FIRST FULFILLMENT MINIMUM DATE
    // Subscription requires 7 days notice
    // ========================================

    var now =
      new Date();

    var today =
      new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );

    /*
      Subscription orders require at least
      7 days advance notice.

      Example:
      Sep 23 → earliest selectable date Sep 30.

      If that date falls on Sunday or a
      U.S. federal holiday, move forward
      to the next available date.
    */

    var minimumDate =
      addDays(
        today,
        7
      );

    while (
      isClosedDate(minimumDate)
    ) {
      minimumDate =
        addDays(
          minimumDate,
          1
        );
    }

    dateInput.min =
      formatDate(minimumDate);


    // ========================================
    // FIND VARIANT
    // ========================================

    function findVariant() {

      var selectedSize =
        normalize(size.value);

      var selectedFrequency =
        normalize(
          frequency.value
        );

      for (
        var i = 0;
        i < data.variants.length;
        i++
      ) {
        var variant =
          data.variants[i];

        var options = [
          normalize(
            variant.option1
          ),
          normalize(
            variant.option2
          ),
          normalize(
            variant.option3
          )
        ];

        if (
          options.indexOf(
            selectedSize
          ) !== -1 &&
          options.indexOf(
            selectedFrequency
          ) !== -1
        ) {
          return variant;
        }
      }

      return null;
    }


    // ========================================
    // VARIANT / PRICE UPDATE
    // ========================================

    function updateProduct() {

      var variant =
        findVariant();

      if (!variant) {
        variantInput.value = '';
        planInput.value = '';

        if (price) {
          price.textContent =
            'Unavailable';
        }

        return null;
      }

      variantInput.value =
        String(variant.id);

      var selectedPlan =
        null;

      if (
        variant.selling_plans &&
        variant.selling_plans.length > 0
      ) {
        selectedPlan =
          variant.selling_plans[0];
      }

      if (selectedPlan) {

        planInput.value =
          String(selectedPlan.id);

        if (price) {

          if (
            selectedPlan.price !== null &&
            selectedPlan.price !== undefined
          ) {
            price.innerHTML =
              '<span style="font-size:14px;color:#bfb3a3;text-decoration:line-through;margin-right:10px;">' +
              money(variant.price) +
              '</span>' +

              '<span style="font-size:21px;color:#f2ece0;">' +
              money(selectedPlan.price) +
              '</span>' +

              '<span style="display:block;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#bfb3a3;margin-top:5px;">5% subscription savings</span>';
          } else {
            price.textContent =
              money(variant.price);
          }
        }

      } else {

        planInput.value = '';

        if (price) {
          price.textContent =
            money(variant.price);
        }
      }

      return variant;
    }


    // ========================================
    // SCHEDULE DISPLAY
    // ========================================

    function updateSchedule() {

      var firstDate =
        parseLocalDate(
          dateInput.value
        );

      var requestedTime =
        timeSelect.value;

      scheduleList.innerHTML = '';

      if (
        !firstDate ||
        !requestedTime
      ) {
        scheduleBox.hidden =
          true;

        return [];
      }

      var schedule =
        buildDeliverySchedule(
          firstDate,
          frequency.value
        );

      for (
        var i = 0;
        i < schedule.length;
        i++
      ) {
        var item =
          schedule[i];

        var row =
          document.createElement(
            'div'
          );

        row.className =
          'jt-subscription-schedule-row';

        var datePart =
          document.createElement(
            'span'
          );

        datePart.textContent =
          formatDisplayDate(
            item.date
          ) +
          ' · ' +
          requestedTime;

        row.appendChild(
          datePart
        );

        if (item.adjusted) {

          var adjustment =
            document.createElement(
              'span'
            );

          adjustment.className =
            'jt-subscription-schedule-adjustment';

          adjustment.textContent =
            'Holiday Adjustment';

          row.appendChild(
            adjustment
          );
        }

        scheduleList.appendChild(
          row
        );
      }

      scheduleBox.hidden =
        false;

      return schedule;
    }


    // ========================================
    // DATE VALIDATION
    // ========================================

    function validateFirstDate(
      showAlert
    ) {
      var selectedDate =
        parseLocalDate(
          dateInput.value
        );

      if (!selectedDate) {
        return false;
      }

      if (isSunday(selectedDate)) {

        if (showAlert) {
          alert(
            'Je T’aime Blooms is closed on Sundays. Please select another first delivery date.'
          );
        }

        dateInput.value = '';
        scheduleBox.hidden =
          true;

        return false;
      }

      if (
        isFederalHoliday(
          selectedDate
        )
      ) {

        if (showAlert) {
          alert(
            'Je T’aime Blooms is closed on U.S. federal holidays. Please select another first delivery date.'
          );
        }

        dateInput.value = '';
        scheduleBox.hidden =
          true;

        return false;
      }

      if (
        selectedDate <
        minimumDate
      ) {

        if (showAlert) {
          alert(
            'Please select an available first delivery date.'
          );
        }

        dateInput.value = '';
        scheduleBox.hidden =
          true;

        return false;
      }

      return true;
    }


    // ========================================
    // EVENTS
    // ========================================

    size.addEventListener(
      'change',
      function () {
        updateProduct();
      }
    );

    frequency.addEventListener(
      'change',
      function () {
        updateProduct();
        updateSchedule();
      }
    );

    dateInput.addEventListener(
      'change',
      function () {

        if (
          !validateFirstDate(true)
        ) {
          return;
        }

        updateSchedule();
      }
    );

    timeSelect.addEventListener(
      'change',
      function () {
        updateSchedule();
      }
    );


    // ========================================
    // SUBMIT
    // ========================================

    form.addEventListener(
      'submit',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        var variant =
          updateProduct();

        if (
          !variant ||
          !variantInput.value
        ) {
          alert(
            'This subscription option could not be found. Please contact us.'
          );

          return;
        }

        if (!planInput.value) {
          alert(
            'The monthly subscription plan is not available for this option. Please contact us.'
          );

          return;
        }

        if (
          !dateInput.value
        ) {
          alert(
            'Please select your first delivery date.'
          );

          return;
        }

        if (
          !validateFirstDate(true)
        ) {
          return;
        }

        if (
          !timeSelect.value
        ) {
          alert(
            'Please select your requested time.'
          );

          return;
        }


        var firstDate =
          parseLocalDate(
            dateInput.value
          );

        var schedule =
          buildDeliverySchedule(
            firstDate,
            frequency.value
          );


        // ========================================
        // BUILD CART SCHEDULE PROPERTY
        // ========================================

        var scheduleLines = [];

        for (
          var i = 0;
          i < schedule.length;
          i++
        ) {
          var item =
            schedule[i];

          var line =
            formatDisplayDate(
              item.date
            );

          if (item.adjusted) {
            line +=
              ' · Holiday Adjustment';
          }

          scheduleLines.push(
            line
          );
        }


        // ========================================
        // ADD TO CART
        // ========================================

        var payload = {
          items: [
            {
              id:
                Number(
                  variantInput.value
                ),

              quantity: 1,

              selling_plan:
                Number(
                  planInput.value
                ),

              properties: {
                'First Delivery Date':
                  formatDate(
                    firstDate
                  ),

                'Requested Time':
                  timeSelect.value,

                'Delivery Schedule':
                  scheduleLines.join(
                    '\n'
                  )
              }
            }
          ]
        };


        var submitButton =
          form.querySelector(
            '.jt-subscription-button'
          );

        if (submitButton) {
          submitButton.disabled =
            true;

          submitButton.textContent =
            'Adding...';
        }


        fetch(
          window.Shopify.routes.root +
          'cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify(
                payload
              )
          }
        )

        .then(function (response) {

          return response
            .json()
            .then(function (result) {

              if (!response.ok) {
                throw result;
              }

              return result;
            });
        })

        .then(function () {

          window.location.href =
            window.Shopify.routes.root +
            'cart';
        })

        .catch(function (error) {

          console.error(
            'Subscription cart error:',
            error
          );

          if (submitButton) {
            submitButton.disabled =
              false;

            submitButton.textContent =
              'Subscribe';
          }

          var message =
            error &&
            error.description
              ? error.description
              : 'We could not add this subscription to your cart.';

          alert(message);
        });
      }
    );


    // ========================================
    // INITIALIZE
    // ========================================

    updateProduct();
    updateSchedule();
  }


  bind('sig');
  bind('mys');

});